export const GoogleMapApiConfig = 'AIzaSyBdqmgELHoD87y3pnwvgM-wxNWIV-L9bbw';